import { apiClient } from "./api";
import { isAxiosError } from "axios";
import { UUID } from "crypto";
import {Profesional} from "@/interfaces/adminInterfaces";

class ProfesionalService {
  private basicURL: string;
  private especialidadURL: string;

  constructor() {
      this.basicURL = "/Profesional";
      this.especialidadURL = "/Especialidad";
  }

  async getEspecialidadesProfesional(idProfesional: UUID) {
      const endpoint = `${this.basicURL}/GetEspecialidadesProfesional`;
      const body = JSON.stringify({
        idProfesional: idProfesional
      });
      try {
        const response = await apiClient.post(endpoint, body);
        return response;
      } catch (error : unknown) {
        if (isAxiosError(error)) {
            return error.response;
        }
        return "Error al traer la lista de especialidades";
      }
  }
  
  async getEspecialidades(){
    const endpoint = `${this.especialidadURL}/ObtenerEspecialidades`;
    try {
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al traer la lista de especialidades";
    }
  }

  async getProfesiones(){
    const endpoint = `${this.especialidadURL}/ObtenerProfesiones`;
    try {
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al traer la lista de profesiones";
    }
  }

  async crearProfesional(profesional: Profesional){
    const endpoint = `${this.basicURL}/AgregarProfesional`;
    const body = JSON.stringify({
      nombres: profesional.nombres,
      apellidos: profesional.apellidos,
      matriculaProvincial: profesional.matriculaProvincial,
      matriculaNacional: profesional.matriculaNacional,
      trabajaConIoma: profesional.trabajaConIoma,
      especialidades: profesional.especialidades,
      cuit: profesional.cuit,
      domicilio: null,
      telefono: null,
      email: null,
      fechaNacimiento: null
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al crear el profesional";
    }
  }

  async editarProfesional(profesional: Profesional){
    const body = JSON.stringify(profesional);
    const endpoint = `${this.basicURL}/EditarProfesional`;
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al editar el profesional";
    }
  }

  async asociarProfesionalFacturador(idProfesional: string, idFacturador: string){
    const endpoint = `${this.basicURL}/AsociarProfesionalFacturador`;
    const body = JSON.stringify({
      idProfesional: idProfesional,
      idFacturador: idFacturador
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al asociar el profesional al facturador";
    }
  }

  async desasociarProfesionalFacturador(idProfesional: string, idFacturador: string){
    const endpoint = `${this.basicURL}/DesasociarProfesionalFacturador`;
    const body = JSON.stringify({
      idProfesional: idProfesional,
      idFacturador: idFacturador
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al asociar el profesional al facturador";
    }
  }

  async asociarProfesionalEspecialidades(idProfesional: string, especialidades: string[]){
    const endpoint = `${this.basicURL}/AsociarProfesionalEspecialidades`;
    const body = JSON.stringify({
      idProfesional: idProfesional,
      especialidades: especialidades
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al asociar las especialidades al profesional";
    }
  }

  async desasociarProfesionalEspecialidad(idProfesional: string, idEspecialidad: string){
    const endpoint = `${this.basicURL}/DesasociarProfesionalEspecialidad`;
    const body = JSON.stringify({
      idProfesional: idProfesional,
      idEspecialidad: idEspecialidad
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al desasociar la especialidad del profesional";
    }
  }

  async getProfesional(dato: string, opcion = 0){
    const endpoint = `${this.basicURL}/GetProfesional`;
    const body = JSON.stringify({
      opcionBusquedaProfesional : opcion,
      dato: dato
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al traer el profesional";
    }
  }

  async getOpcionesBusqueda(){
    const endpoint = `${this.basicURL}/GetOpcionesBusquedaProfesional`;
    try {
      const response = await apiClient.post(endpoint);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
          return error.response;
      }
      return "Error al traer las opciones de búsqueda del profesional";
    }
  }
}

export default ProfesionalService;